/* MixNorth theme JS — cart (real Shopify Ajax Cart API), wishlist (localStorage), mega menu,
   quick add, cart drawer, chat widget mock, product option picker. */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------------- Cart drawer open/close ---------------- */
  function getDrawerEls() {
    return {
      drawer: document.getElementById('mn-cart-drawer'),
      overlay: document.querySelector('.mn-cart-overlay'),
    };
  }

  function openCartDrawer() {
    const { drawer, overlay } = getDrawerEls();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    const { drawer, overlay } = getDrawerEls();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-open]')) {
      e.preventDefault();
      openCartDrawer();
    }
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeCartDrawer();
    }
  });

  /* ---------------- Cart section refresh (Section Rendering API) ---------------- */
  function refreshCartDrawer(thenOpen) {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', 'cart-drawer');
    return fetch(url.toString())
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const temp = document.createElement('div');
        temp.innerHTML = html.trim();
        const newSection = temp.querySelector('#shopify-section-cart-drawer') || temp.firstElementChild;
        const current = document.getElementById('shopify-section-cart-drawer');
        if (newSection && current && current.parentNode) {
          current.parentNode.replaceChild(newSection, current);
        }
        if (thenOpen) openCartDrawer();
      })
      .catch(function (err) { console.error('MixNorth: failed to refresh cart drawer', err); });
  }

  function syncCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
      })
      .catch(function () {});
  }

  /* ---------------- Quick add / Add to cart ---------------- */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw e; });
      return res.json();
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    addToCart(variantId, 1)
      .then(function () { return refreshCartDrawer(true); })
      .then(syncCartCount)
      .catch(function (err) {
        console.error('MixNorth: quick add failed', err);
        alert(err && err.description ? err.description : 'Could not add this item to your bag.');
      })
      .finally(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });

  /* Main product form add-to-cart (uses native form submit but intercepted for the drawer UX) */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('#mn-product-form');
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function () { return refreshCartDrawer(true); })
      .then(syncCartCount)
      .catch(function (err) {
        alert(err && err.description ? err.description : 'Could not add this item to your bag.');
      });
  });

  /* ---------------- Cart line qty stepper (event delegation, works after drawer refresh) ---------------- */
  function changeLineQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (res) { return res.json(); });
  }

  document.addEventListener('click', function (e) {
    const incBtn = e.target.closest('[data-cart-qty-increase]');
    const decBtn = e.target.closest('[data-cart-qty-decrease]');
    const target = incBtn || decBtn;
    if (!target) return;
    e.preventDefault();
    const key = target.getAttribute('data-line-key');
    const line = target.closest('[data-cart-line]');
    const qtyEl = line ? line.querySelector('[data-cart-qty]') : null;
    const current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
    const next = incBtn ? current + 1 : Math.max(0, current - 1);
    changeLineQuantity(key, next)
      .then(function () { return refreshCartDrawer(false); })
      .then(syncCartCount);
  });

  /* ---------------- Wishlist (localStorage, per README: persist to customer metafield / app in the future) ---------------- */
  const WISHLIST_KEY = 'mn_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function renderWishlistState() {
    const list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      const id = btn.getAttribute('data-product-id');
      const icon = btn.querySelector('[data-wish-icon]');
      if (icon) icon.textContent = list.indexOf(id) > -1 ? '♥' : '♡';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.style.display = list.length > 0 ? 'flex' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-product-id');
    let list = getWishlist();
    if (list.indexOf(id) > -1) {
      list = list.filter(function (x) { return x !== id; });
    } else {
      list.push(id);
    }
    setWishlist(list);
    renderWishlistState();
  });

  /* ---------------- Newsletter button label (client-side hint; server already handles real subscribe) ---------------- */
  const newsletterForm = document.getElementById('mn-newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function () {
      const btn = document.querySelector('[data-newsletter-btn]');
      if (btn) btn.textContent = 'Subscribing…';
    });
  }

  /* ---------------- Newsletter discount popup ----------------
     Real subscribe via Shopify's customer form (fetch, no reload), then reveals the
     discount code set in the section. Dismissal is remembered in localStorage for
     "reshow_days" so returning visitors aren't nagged. To also have Shopify email the
     code automatically, wire up a free Shopify Flow — see the install guide. */
  const POPUP_DISMISS_KEY = 'mn_popup_dismissed_at';
  const popupOverlay = document.getElementById('mn-popup-overlay');
  const popup = document.getElementById('mn-popup');
  const popupCloseBtn = document.getElementById('mn-popup-close');
  const popupForm = document.getElementById('mn-popup-form');
  const popupSignup = document.getElementById('mn-popup-signup');
  const popupSuccess = document.getElementById('mn-popup-success');
  const popupContinueBtn = document.getElementById('mn-popup-continue');
  const popupCopyBtn = document.getElementById('mn-popup-copy-btn');
  const popupCodeEl = document.getElementById('mn-popup-code');

  function openPopup() {
    if (!popup) return;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    if (popupOverlay) popupOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(remember) {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    if (popupOverlay) popupOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (remember) {
      try { localStorage.setItem(POPUP_DISMISS_KEY, String(Date.now())); } catch (e) {}
    }
  }

  if (popupOverlay && popup) {
    const delaySeconds = parseInt(popupOverlay.getAttribute('data-delay-seconds'), 10) || 0;
    const reshowDays = parseInt(popupOverlay.getAttribute('data-reshow-days'), 10) || 30;
    const alreadySubscribed = popupOverlay.getAttribute('data-already-subscribed') === 'true';

    let shouldShow = !alreadySubscribed;
    if (shouldShow) {
      try {
        const last = parseInt(localStorage.getItem(POPUP_DISMISS_KEY), 10);
        if (last) {
          const elapsedDays = (Date.now() - last) / 86400000;
          if (elapsedDays < reshowDays) shouldShow = false;
        }
      } catch (e) {}
    }

    if (shouldShow) {
      setTimeout(openPopup, delaySeconds * 1000);
    }
  }

  // Only the explicit X (or the "Continue shopping" button after the code is revealed) closes
  // the popup. Clicking the dimmed background does NOT close it — that was causing the popup
  // (and the just-revealed discount code) to vanish accidentally, especially right after
  // submitting on mobile when the keyboard dismisses.
  if (popupCloseBtn) popupCloseBtn.addEventListener('click', function () { closePopup(true); });
  if (popupContinueBtn) popupContinueBtn.addEventListener('click', function () { closePopup(true); });

  if (popupForm) {
    popupForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const submitBtn = document.getElementById('mn-popup-submit');
      const formData = new FormData(popupForm);
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

      fetch(popupForm.action || '/contact', {
        method: 'POST',
        headers: { Accept: 'text/html' },
        body: formData,
      })
        .then(function () {
          if (popupSignup) popupSignup.hidden = true;
          if (popupSuccess) popupSuccess.hidden = false;
          try { localStorage.setItem(POPUP_DISMISS_KEY, String(Date.now())); } catch (err) {}
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Continue'; }
          alert("That didn't go through — please try again.");
        });
    });
  }

  if (popupCopyBtn && popupCodeEl) {
    popupCopyBtn.addEventListener('click', function () {
      const code = popupCodeEl.textContent.trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          popupCopyBtn.textContent = 'Copied';
          setTimeout(function () { popupCopyBtn.textContent = 'Copy'; }, 1800);
        });
      }
    });
  }

  /* ---------------- Chat widget — real submissions via Shopify's native contact form ----------------
     Every message is POSTed to the same endpoint Shopify's built-in contact page uses, so it
     actually arrives as an email to the store's Settings > Notifications recipient address.
     This is not a canned bot: the "reply" shown here just confirms delivery. The hub view's
     FAQ search and order-status links use Shopify's own routes; the shopping assistant search
     calls Shopify's public predictive-search endpoint (no key required) for live product
     suggestions with real images and prices. */
  const chatFab = document.getElementById('mn-chat-fab');
  const chatPanel = document.getElementById('mn-chat-panel');
  const chatHub = document.getElementById('mn-chat-hub');
  const chatMessagesView = document.getElementById('mn-chat-messages-view');
  const chatLeaveMsgBtn = document.getElementById('mn-chat-leave-msg');
  const chatBackBtn = document.getElementById('mn-chat-back');
  const chatForm = document.getElementById('mn-chat-form');
  const chatInput = document.getElementById('mn-chat-input');
  const chatEmailField = document.getElementById('mn-chat-email-field');
  const chatSendBtn = document.getElementById('mn-chat-send-btn');
  const chatMessages = document.getElementById('mn-chat-messages');
  const chatAssistantInput = document.getElementById('mn-chat-assistant-input');
  const chatAssistantBtn = document.getElementById('mn-chat-assistant-btn');
  const chatAssistantResults = document.getElementById('mn-chat-assistant-results');

  /* Auto-answer bot — rule-based, powered by "Auto-answer" blocks on the Chat widget section
     (keywords + answer, editable in the theme editor). Genuinely answers instantly client-side;
     no external API or key involved. Anything that doesn't match still gets relayed as a real
     email via the form below, so nothing is ever silently ignored. */
  let chatFaqData = [];
  const chatFaqDataEl = document.getElementById('mn-chat-faq-answers');
  if (chatFaqDataEl) {
    try { chatFaqData = JSON.parse(chatFaqDataEl.textContent) || []; } catch (e) { chatFaqData = []; }
  }
  function findFaqAnswer(text) {
    const lower = text.toLowerCase();
    for (let i = 0; i < chatFaqData.length; i++) {
      const entry = chatFaqData[i];
      if (!entry || !entry.keywords) continue;
      const keywords = entry.keywords.split(',').map(function (k) { return k.trim().toLowerCase(); }).filter(Boolean);
      for (let j = 0; j < keywords.length; j++) {
        if (keywords[j] && lower.indexOf(keywords[j]) !== -1) return entry.answer;
      }
    }
    return null;
  }

  if (chatFab && chatPanel) {
    chatFab.addEventListener('click', function () {
      const willOpen = !chatPanel.classList.contains('is-open');
      chatPanel.classList.toggle('is-open', willOpen);
      chatPanel.setAttribute('aria-hidden', String(!willOpen));
      const icon = chatFab.querySelector('[data-chat-icon]');
      if (icon) icon.textContent = willOpen ? '✕' : '💬';
    });
  }

  function showChatMessagesView() {
    if (chatHub) chatHub.hidden = true;
    if (chatMessagesView) chatMessagesView.hidden = false;
    if (chatLeaveMsgBtn) chatLeaveMsgBtn.hidden = true;
    if (chatInput) chatInput.focus();
  }
  function showChatHub() {
    if (chatMessagesView) chatMessagesView.hidden = true;
    if (chatHub) chatHub.hidden = false;
    if (chatLeaveMsgBtn) chatLeaveMsgBtn.hidden = false;
  }
  if (chatLeaveMsgBtn) chatLeaveMsgBtn.addEventListener('click', showChatMessagesView);
  if (chatBackBtn) chatBackBtn.addEventListener('click', showChatHub);

  /* Shopping assistant — live product search via Shopify's public predictive search API. */
  let assistantTimer = null;
  function runAssistantSearch() {
    const q = (chatAssistantInput.value || '').trim();
    if (!chatAssistantResults) return;
    if (!q) {
      chatAssistantResults.innerHTML = '';
      return;
    }
    chatAssistantResults.innerHTML = '<div class="mn-chat-assistant-empty">Searching…</div>';
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,vendor')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          chatAssistantResults.innerHTML = '<div class="mn-chat-assistant-empty">No matches — try a different search, or leave us a message.</div>';
          return;
        }
        chatAssistantResults.innerHTML = products.map(function (p) {
          const img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<img src="" alt="" loading="lazy" style="background:var(--reviews-bg)">';
          return '<a class="mn-chat-assistant-item" href="' + p.url + '">' + img +
            '<span><span class="mn-chat-assistant-item-title">' + p.title + '</span><br>' +
            '<span class="mn-chat-assistant-item-price">' + (p.price || '') + '</span></span></a>';
        }).join('');
      })
      .catch(function () {
        chatAssistantResults.innerHTML = '<div class="mn-chat-assistant-empty">Search is unavailable right now — try browsing the store or leave us a message.</div>';
      });
  }
  if (chatAssistantInput) {
    chatAssistantInput.addEventListener('input', function () {
      clearTimeout(assistantTimer);
      assistantTimer = setTimeout(runAssistantSearch, 350);
    });
    chatAssistantInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(assistantTimer); runAssistantSearch(); }
    });
  }
  if (chatAssistantBtn) chatAssistantBtn.addEventListener('click', runAssistantSearch);

  if (chatForm) {
    chatForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const text = (chatInput.value || '').trim();
      if (!text) return;

      // Try the instant auto-answer bot first — no email needed, no page reload, replies right away.
      const faqAnswer = findFaqAnswer(text);
      if (faqAnswer) {
        appendChatMessage(text, 'user');
        chatInput.value = '';
        appendChatMessage(faqAnswer, 'bot');
        chatInput.focus();
        return;
      }

      const email = chatEmailField ? (chatEmailField.value || '').trim() : null;
      if (chatEmailField && !email) {
        chatEmailField.focus();
        return;
      }

      appendChatMessage(text, 'user');
      const formData = new FormData(chatForm);
      chatInput.value = '';
      chatInput.disabled = true;
      if (chatSendBtn) chatSendBtn.disabled = true;

      fetch(chatForm.action || '/contact', {
        method: 'POST',
        headers: { Accept: 'text/html' },
        body: formData,
      })
        .then(function (res) {
          if (chatEmailField) {
            // Keep the email so follow-up messages in this session don't ask again.
            chatEmailField.type = 'hidden';
          }
          if (res.ok) {
            appendChatMessage("Thanks — that's been sent to our team and we'll reply to " + (email || 'your account email') + " shortly. In the meantime, check our Shipping and FAQ pages for quick answers.", 'bot');
          } else {
            appendChatMessage("Hmm, that message didn't go through. Please try again, or email us directly.", 'bot');
          }
        })
        .catch(function () {
          appendChatMessage("Hmm, that message didn't go through — check your connection and try again.", 'bot');
        })
        .finally(function () {
          chatInput.disabled = false;
          if (chatSendBtn) chatSendBtn.disabled = false;
          chatInput.focus();
        });
    });
  }

  function appendChatMessage(text, from) {
    if (!chatMessages) return;
    const div = document.createElement('div');
    div.className = 'mn-chat-msg from-' + from;
    div.textContent = text;
    chatMessages.appendChild(div);
    chatMessages.scrollTop = chatMessages.scrollHeight;
  }

  /* ---------------- Mobile mega-menu tap support (desktop uses CSS hover) ---------------- */
  document.querySelectorAll('.mn-nav-item').forEach(function (item) {
    const mega = item.querySelector('.mn-mega');
    if (!mega) return;
    const link = item.querySelector('a');
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        item.classList.toggle('is-open');
      }
    });
  });

  /* ---------------- Mobile nav drawer (hamburger) ---------------- */
  const mobileNav = document.getElementById('mn-mobile-nav');
  const mobileNavOverlay = document.getElementById('mn-mobile-nav-overlay');
  const mobileNavOpenBtn = document.getElementById('mn-mobile-nav-open');
  const mobileNavCloseBtn = document.getElementById('mn-mobile-nav-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('is-open');
    if (mobileNavOpenBtn) mobileNavOpenBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-open');
    if (mobileNavOpenBtn) mobileNavOpenBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileNavOpenBtn) mobileNavOpenBtn.addEventListener('click', openMobileNav);
  if (mobileNavCloseBtn) mobileNavCloseBtn.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  // "+" accordion toggle for nav items with sub-links (e.g. Sneakers, Apparel)
  document.querySelectorAll('.mn-mobile-nav-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('.mn-mobile-nav-item');
      if (!item) return;
      const willOpen = !item.classList.contains('is-open');
      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
      btn.textContent = willOpen ? '−' : '+';
    });
  });

  /* ---------------- Product page: option picker + gallery thumbnails ---------------- */
  const productForm = document.getElementById('mn-product-form');
  if (productForm) {
    const variantsEl = document.getElementById('mn-product-json');
    let variants = [];
    try { variants = variantsEl ? JSON.parse(variantsEl.textContent) : []; } catch (e) { variants = []; }

    const optionButtons = document.querySelectorAll('.mn-option-btn');
    const selectedOptions = {};
    optionButtons.forEach(function (btn) {
      if (btn.style.background && btn.style.background.indexOf('rgb(17') === 0) {
        selectedOptions[btn.getAttribute('data-option-index')] = btn.getAttribute('data-option-value');
      }
    });

    function findMatchingVariant() {
      return variants.find(function (v) {
        const opts = [v.option1, v.option2, v.option3];
        return Object.keys(selectedOptions).every(function (idx) {
          return opts[idx] === selectedOptions[idx];
        });
      });
    }

    function updateProductUI(variant) {
      const priceEl = document.getElementById('mn-product-price');
      const compareEl = document.getElementById('mn-product-compare');
      const idInput = document.getElementById('mn-selected-variant-id');
      const addBtn = document.getElementById('mn-product-add-btn');
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (addBtn.getAttribute('data-label-add') || 'Add to bag') : 'Sold out';
      }
    }

    function formatMoney(cents) {
      return (window.Shopify && window.Shopify.formatMoney)
        ? window.Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const idx = btn.getAttribute('data-option-index');
        const value = btn.getAttribute('data-option-value');
        selectedOptions[idx] = value;

        document.querySelectorAll('.mn-option-btn[data-option-index="' + idx + '"]').forEach(function (b) {
          const active = b === btn;
          b.style.background = active ? 'var(--ink)' : 'transparent';
          b.style.color = active ? '#fff' : 'var(--ink)';
        });

        const match = findMatchingVariant();
        if (match) updateProductUI(match);
      });
    });

    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const full = thumb.getAttribute('data-full');
        const mainImg = document.getElementById('mn-product-main-image');
        if (mainImg && full) mainImg.src = full;
      });
    });
  }

  /* ---------------- Real customer reviews (from assets/reviews.json, built from the MixNorth
     Loox export — 301 published reviews, 133 with customer photos). This still powers only the
     star/review-count badge on trending product-grid cards (a purely informational, non-editable
     summary). The homepage reviews section and the product-page reviews are both native
     Shopify blocks now (see sections/customer-reviews.liquid and sections/main-product.liquid),
     so they're editable in the theme editor and don't need any JS rendering. ---------------- */
  const reviewsCache = {};

  function getReviewsData(url) {
    if (!url) return Promise.resolve(null);
    if (reviewsCache[url]) return reviewsCache[url];
    reviewsCache[url] = fetch(url)
      .then(function (res) { return res.json(); })
      .catch(function (err) {
        console.error('MixNorth: failed to load reviews.json', err);
        return null;
      });
    return reviewsCache[url];
  }

  function starString(rating) {
    const r = Math.round(rating || 0);
    return '★★★★★☆☆☆☆☆'.slice(5 - r, 10 - r);
  }

  function reviewsJsonUrl() {
    return document.body.getAttribute('data-reviews-json-url');
  }

  function initProductCardRatings() {
    // Product cards render the handle on the outer [data-product-card]; the rating row is a child.
    const cards = document.querySelectorAll('[data-product-card][data-product-handle]');
    if (!cards.length) return;
    getReviewsData(reviewsJsonUrl()).then(function (data) {
      if (!data) return;
      cards.forEach(function (card) {
        const handle = card.getAttribute('data-product-handle');
        const row = card.querySelector('[data-review-rating-target]');
        if (!row || !handle) return;
        applyRatingToRow(row, data.reviews.filter(function (r) { return r.handle === handle; }));
      });
    });
  }

  function applyRatingToRow(row, matches) {
    const summaryEl = row.querySelector('[data-review-summary]');
    if (!matches.length) {
      row.setAttribute('data-review-empty', 'true');
      if (summaryEl) summaryEl.textContent = 'No reviews yet';
      return;
    }
    const avg = matches.reduce(function (s, r) { return s + r.rating; }, 0) / matches.length;
    row.setAttribute('data-review-empty', 'false');
    row.innerHTML = '<span class="mn-stars">' + starString(avg) + '</span><span class="mn-review-count">(' + matches.length + ')</span>';
  }

  /* ---------------- Init ---------------- */
  document.addEventListener('DOMContentLoaded', function () {
    renderWishlistState();
    initProductCardRatings();
  });
  if (document.readyState !== 'loading') {
    renderWishlistState();
    initProductCardRatings();
  }
})();
